import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import TaskService from '../../services/TaskService'
import { useNotification } from '../../context/NotificationContext'

const DeleteTasksConfirmationModal = ({
  deleteOpen,
  setDeleteOpen,
  tasksToggler,
  setTasksToggler,
  tasksToDelete,
  setCheckedTasks
}) => {
  const showNotification = useNotification()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDeleteProjects = async () => {
    setLoading(true)
    try {
      await TaskService.deleteTasksByIds(tasksToDelete)
      if (tasksToDelete.length > 1) {
        showNotification('Tasks have been deleted successfully', 'success', '', navigate, '/tasks')
      } else {
        showNotification('Task has been deleted successfully', 'success', '', navigate, '/tasks')
      }
      setCheckedTasks([])
      setTasksToggler(!tasksToggler)
    } catch (error) {
      console.log(error.message)
      showNotification('Task(s) could not be deleted', 'error', '', navigate)
    } finally {
      setLoading(false)
      setDeleteOpen(false)
    }
  }

  return (
    <Dialog
      open={deleteOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTasksModal">
        <DialogTitle className="deleteTasksModalTitle">
          Confirm Delete Task
          {tasksToDelete.length > 1 && "s"}
        </DialogTitle>
        <DialogContent className="deleteTasksModalContent">
          <DialogContentText className="deleteTasksModalContentText">
            Are you sure you want to delete {tasksToDelete.length > 1 ? "these" : "this"} task{tasksToDelete.length > 1 && "s"}? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTasksModalActions">
          <Button className="deleteTasksModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTasksModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTasksModalButton" onClick={handleDeleteProjects} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTasksConfirmationModal